/**
 * Individual global variables for anything.
 *
 * @todo Implement - Language switch
 * @todo Optimize - Move global application variables here
 */
const globals: any = {
  locale: {
    currency: "EUR",
    lang: "de",
    langCode: "de-DE",
  },
}

export default globals
